import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BarChart3, Building2, CalendarDays, FileText, Heart, ShieldCheck, UserRound, Users, Zap } from "lucide-react";

export const WhyWorkWithMe: React.FC = () => (
  <section className="why-work" aria-labelledby="why-work-heading">
    <div className="container-x">
      <div className="why-work-panel">
        <p className="why-work-label"><span aria-hidden="true" />Why Work With Me</p>
        <div className="why-work-heading">
          <div>
            <h2 id="why-work-heading">More Than Just a <span>Car Sale</span></h2>
            <p>Personal guidance, honest advice, and support that stays with you beyond the showroom.</p>
          </div>
          <div className="why-work-stats">
            {[
              { Icon: BarChart3, title: "600+", detail: "Cars Sold Over 5 Years" },
              { Icon: Users, title: "Personal", detail: "One-on-One Guidance" },
              { Icon: Building2, title: "Trusted", detail: "Toyota Tokai Affiliation" },
            ].map(({ Icon, title, detail }) => <div key={title}><span className="why-work-icon"><Icon aria-hidden="true" /></span><div><strong>{title}</strong><small>{detail}</small></div></div>)}
          </div>
        </div>
        <div className="why-work-cards">
          {[
            { Icon: UserRound, title: "Personalised Service", description: "I take the time to understand your needs and help you find the right vehicle for your lifestyle and budget." },
            { Icon: ShieldCheck, title: "Honest & Transparent", description: "Clear answers, straightforward advice, and a buying experience built on trust from day one." },
            { Icon: Heart, title: "Ongoing Support", description: "My relationship with you doesn’t end after the sale — I’m here to help through the journey." },
          ].map(({ Icon, title, description }) => <article key={title}><span className="why-work-icon"><Icon aria-hidden="true" /></span><h3>{title}</h3><p>{description}</p></article>)}
        </div>
        <div className="why-work-contact">
          <div className="why-work-contact-copy">
            <p className="why-work-label"><span aria-hidden="true" />Let’s Get You On The Road</p>
            <h3>Ready to talk about your next car?</h3>
            <p>Whether you want to enquire, book a viewing, or ask a few questions, I’m here to help you take the next step with confidence.</p>
            <div className="why-work-actions"><Link to="/contact/">Get In Touch <ArrowRight aria-hidden="true" /></Link><Link to="/vehicles/">Browse Vehicles <ArrowRight aria-hidden="true" /></Link></div>
            <p className="why-work-signoff">Driven by people. Powered by Toyota.</p>
          </div>
          <div className="why-work-perks">
            {[
              { Icon: CalendarDays, title: "Book a Viewing", detail: "At a time that suits you." },
              { Icon: Zap, title: "Quick Responses", detail: "Get the answers you need, fast." },
              { Icon: FileText, title: "Easy Enquiries", detail: "A simple, hassle-free process." },
            ].map(({ Icon, title, detail }) => <div key={title}><Icon aria-hidden="true" /><div><strong>{title}</strong><p>{detail}</p></div></div>)}
          </div>
          <img className="why-work-photo" src="/images/dealership-reference.png" alt="Market Toyota dealership exterior" loading="lazy" />
        </div>
      </div>
    </div>
  </section>
);
